(function($) {
    //////////////////////////////////////////////////////////////////////////////
    //tabTrapping 5.0
    //////////////////////////////////////////////////////////////////////////////
    //
    // to intitualize this plugin all you have to do is add this to your javascript file:
    //
    //////////////////////////////////////////////////////////////
    // $("body").tabTrapping();
    //////////////////////////////////////////////////////////////
    //
    // this is an empty panel, you have to have it closed or opened
    // you need ether = "panel-closed or panel-opened" in class
    // if you want it to close if you click anything else, add "panel-overlay" class to it
    // if its a popout type of panel, add "panel-pop", a div with a 
    // class of ".popout-bg" will appear in inside the panel div
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //																												//											
    //      <div class="(panel-closed or panel-opened)(panel-overlay, panel-pop, or none)" ncr-panel="menu"></div>		//
    //																												//
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //
    // this is the panel toggle, you have to have it closed or opened
    // the panel-closed or panel-opened class will show up automatilly depending on what you put in the panel
    //////////////////////////////////////////////////////////////
    //															//
    //          <a href="#" ncr-toggle="menu"></a>				//
    //															//
    //////////////////////////////////////////////////////////////
    //
    //
    // put this button inside a panel-pop, to close it with a button.
    //////////////////////////////////////////////////////////////
    //															//
    //			<a href="#" class="close-button"></a>           //
    //														    //
    //////////////////////////////////////////////////////////////

    $.fn.tabTrapping = function(options, callback) {

        var settings = $.extend({
            preloadRemoveDelay: 0
        }, options)

        var allPanels = $(this).find('[ncr-panel]');

        if ($('.feature-wrap').hasClass('single-open')) {
            var panels = $('.single-open').find('[ncr-panel]');
            // console.log(panels.attr('ncr-panel'));
            panels.each(function() {
                $(this).addClass('panel-accordion');
            })
        };

        allPanels.each(function() {

                var thePanel = {
                    panel: $(this),
                    toggle: $(this).attr('ncr-panel')

                };

                //initial main variables set up
                var ncr_panel = $(this);
                var panel_attr = ncr_panel.attr('ncr-panel');
                var ncr_toggle = $('[ncr-toggle="' + panel_attr + '"]');
                var ncr_toggle_attr = ncr_toggle.attr('ncr-toggle');

                var close_button = ncr_panel.find('.close-button');
                var width = theWindow.width();
                var isitpop = false;
                var isitoverlay = false;
                var child_panels = ncr_panel.find('[ncr-panel]');



                //intial setup for elements
                function intialSetupForElements(this_panel, this_toggle) {
                    //add data- class
                    ncr_toggle.addClass('ncr-toggle');
                    // $(ncr_panel).addClass('ncr-panel');

                    var ncr_toggle_close = $('.ncr-toggle.panel-closed');
                    var ncr_toggle_open = $('.ncr-toggle.panel-opened');
                    var ncr_panel_close = $('div.panel-closed');
                    var ncr_panel_open = $('div.panel-opened');
                    var childrenOfPanel = ncr_panel.find('[ncr-panel]');
                    var childrenOfPanelToggle = ncr_panel.find('[ncr-toggle]');

                    //adds all aria related attributes 
                    ncr_toggle.css('pointer-events', 'auto'); // forces pointer-events auto on all toggles
                    ncr_panel_close.attr("aria-expanded", "false").css('pointer-events', 'none');
                    ncr_panel_close.find('select, input, textarea, button, a').attr('tabIndex', '-1');
                    ncr_panel_open.attr("aria-expanded", "true");
                    ncr_toggle_close.attr("aria-expanded", "false");
                    ncr_toggle_open.attr("aria-expanded", "true");


                    if (ncr_panel.attr("aria-label") == "" || ncr_panel.attr("aria-label") == undefined) {
                        ncr_panel.attr('aria-label', '' + panel_attr + ' Primary');
                    }
                    if (ncr_toggle.attr("aria-label") == "" || ncr_toggle.attr("aria-label") == undefined) {
                        ncr_toggle.attr('aria-label', '' + panel_attr + ' Toggle');
                    }
                    if (close_button.attr("aria-label") == "" || close_button.attr("aria-label") == undefined) {
                        close_button.attr('aria-label', '' + panel_attr + ' close Button');
                    }

                    childrenOfPanel.each(function() {
                        childrenOfPanel.addClass('child-panel');
                        childrenOfPanelToggle.addClass('child-panel');
                    });
                    this_panel.each(function() {
                            var level = $(this).parents('[ncr-panel]').length + 1;

                            $(this).addClass('level-' + level);
                            this_toggle.addClass('level-' + level);
                        })
                        //adds panel-overlay to toggle
                    if (settings.popout == true || this_panel.hasClass('panel-pop')) {
                        $(this_panel).addClass('panel-pop');
                        $(this_toggle).addClass('panel-pop');
                    }
                    //adds panel-overlay to toggle
                    else if (settings.overlay == true || this_panel.hasClass('panel-overlay')) {
                        $(this_panel).addClass('panel-overlay');
                        $(this_toggle).addClass('panel-overlay');
                    }
                    //adds popout-bg div to panel-pops
                    if ($(this_panel).hasClass('panel-pop')) {
                        if ($(this_panel).children('.popout-bg').length == 0) {
                            $(this_panel).append('<div class="popout-bg"></div>');
                        }
                    }
                    //adds popout-bg div to panel-pops
                    if ($(this_panel).hasClass('track-history')) {
                        $(this_toggle).addClass('track-history');
                    }
                    //adds panel-accordion to toggle
                    else if ($(this_panel).hasClass('panel-accordion')) {
                        $(this_toggle).addClass('panel-accordion');
                    }
                    //adds panel-closed to toggle
                    else if ($(this_panel).hasClass('panel-closed')) {
                        $(this_toggle).addClass('panel-closed');
                    }
                    //adds panel-opened to toggle
                    else if ($(this_panel).hasClass('panel-opened')) {
                        $(this_toggle).addClass('panel-opened');
                    }
                }

                //start
                intialSetupForElements(ncr_panel, ncr_toggle);

                //ncr-close-panel / ncr-open-panel custom .on()
                ncr_panel.on("ncr-close-panel", function() {
                    ncr_panel_close_settings(ncr_toggle, panel_attr);
                });
                ncr_panel.on("ncr-open-panel", function() {
                    ncr_panel_open_settings(ncr_toggle, panel_attr);
                    trappingTab(ncr_panel);
                });

                //returns if turned off based on class
                function ifTurnedOff() {
                    if (ncr_panel.is('[class*=panel-off-]')) {
                        return true;
                    } else {
                        return false;
                    }
                }

                //returns when its turned off
                function turnedOffabove() {
                    if (ncr_panel.is('[class*=panel-off-]')) {
                        var result = undefined;
                        $(ncr_panel.attr('class').split(' ')).each(function() {
                            if (this.indexOf('panel-off-') > -1) result = this;
                        });
                        var res = result.split('-')[2];
                    } else {
                        return res = 'on';
                    }
                    return res;
                }

                function turnedOffaboveNumber() {
                    var element_id = ncr_panel.attr('class');
                    var number = element_id.match(/\d+/);
                    return number;
                }

                //targets after initial setup
                var popout_bg = ncr_panel.find('.popout-bg');
                var overlay_panel = $('.panel-overlay');
                var popout_panel = $('.panel-pop');
                var level = ncr_panel.parents('[ncr-panel]').length + 1;






                //function called to open panel
                function ncr_panel_open_settings(dataBtn, data) {
                    var ncr_toggle_attr =
                        dataBtn.attr("aria-expanded", "true")
                        .addClass("panel-opened")
                        .removeClass("panel-closed");

                    var ncr_panel =
                        $('div[ncr-panel="' + data + '"]')
                        .attr("aria-expanded", "true")
                        .addClass("panel-opened")
                        .removeClass("panel-closed")
                        .css('pointer-events', 'auto');

                    var ncr_panel_inputs =
                        $('div[ncr-panel="' + data + '"]')
                        .find('select, input, textarea, button, a')
                        .attr('tabIndex', '0')

                    $('div[ncr-panel="' + data + '"]').find('.panel-closed[ncr-panel]')
                        .find('select, input, textarea, button, a')
                        .attr('tabIndex', '-1');

                    ncr_panel.trigger("ncr-panel-opened");


                    return ncr_toggle_attr, ncr_panel, ncr_panel_inputs;
                }

                //function called to close panel
                function ncr_panel_close_settings(dataBtn, data) {
                    var ncr_toggle_attr =
                        dataBtn.attr("aria-expanded", "false")
                        .addClass("panel-closed")
                        .removeClass("panel-opened");

                    var ncr_panel =
                        $('div[ncr-panel="' + data + '"]')
                        .attr("aria-expanded", "false")
                        .removeClass("panel-opened")
                        .addClass("panel-closed")
                        .css('pointer-events', 'none');

                    var ncr_panel_inputs =
                        $('div[ncr-panel="' + data + '"]')
                        .find('select, input, textarea, button, a')
                        .attr('tabIndex', '-1');


                    // if ($('div[ncr-panel="' + data + '"]').hasClass('track-history')) {
                    //     var uri = window.location.toString();
                    //     if (uri.indexOf("?") > 0) {
                    //         var clean_uri = uri.substring(0, uri.indexOf("?"));
                    //         window.history.replaceState({}, document.title, clean_uri, function() {});
                    //     }
                    // }

                    ncr_panel.trigger("ncr-panel-closed");

                    return ncr_toggle_attr, ncr_panel, ncr_panel_inputs;
                }

                //close all children
                function closeChildren(parentPanel) {
                    var childrenOfPanel = parentPanel.find('.child-panel[ncr-panel]');
                    var childrenOfPanelToggle = parentPanel.find('.child-panel[ncr-toggle]');

                    childrenOfPanel.each(function() {
                        var ncr_toggle_attr =
                            $(childrenOfPanelToggle).attr("aria-expanded", "false")
                            .addClass("panel-closed")
                            .removeClass("panel-opened");

                        var ncr_panel =
                            childrenOfPanel
                            .attr("aria-expanded", "false")
                            .removeClass("panel-opened")
                            .addClass("panel-closed")
                            .css('pointer-events', 'none');

                        var ncr_panel_inputs =
                            childrenOfPanel
                            .find('select, input, textarea, button, a')
                            .attr('tabIndex', '-1');


                        return ncr_toggle_attr, ncr_panel, ncr_panel_inputs;
                    })
                }

                //open all children
                function openChildren() {
                    var childrenOfPanel = ncr_panel.find('.child-panel[ncr-panel]');
                    var childrenOfPanelToggle = ncr_panel.find('.child-panel[ncr-toggle]');

                    childrenOfPanel.each(function() {
                        var ncr_toggle_attr =
                            childrenOfPanelToggle.attr("aria-expanded", "true")
                            .addClass("panel-opened")
                            .removeClass("panel-closed");

                        var ncr_panel =
                            childrenOfPanel
                            .attr("aria-expanded", "true")
                            .removeClass("panel-closed")
                            .addClass("panel-opened")
                            .css('pointer-events', 'auto');

                        var ncr_panel_inputs =
                            childrenOfPanel
                            .find('select, input, textarea, button, a')
                            .attr('tabIndex', '0');


                        return ncr_toggle_attr, ncr_panel, ncr_panel_inputs;
                    })
                }

                //tab trap
                function trappingTab(panel) {

                    //selecting elements to tab through *thanks to the greatness of jordan
                    var allElements = panel.find(':not([ncr-panel].panel-closed, [ncr-panel].panel-closed *)');
                    var tabbable = allElements.filter('select:visible, input:visible, textarea:visible, a:visible, button:visible');

                    var firstTabbable = tabbable.first();
                    var lastTabbable = tabbable.last();


                    //set focus on first input
                    if (ncr_panel.hasClass('auto-focus')) {
                        firstTabbable.focus();
                    }


                    //first tab
                    ncr_toggle.on('keydown', function(e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            if ((ifTurnedOff()) && (width > turnedOffabove())) {
                                e.stopImmediatePropagation();
                            } else {
                                if ($(this).hasClass('panel-opened')) {
                                    e.preventDefault();
                                    firstTabbable.focus();
                                } else {
                                    e.stopImmediatePropagation();
                                }
                            }
                        }
                    });

                    //check if to traptab or not
                    if (!(panel.hasClass('panel-no-trap'))) {
                        //first shift-tab
                        ncr_toggle.on('keydown', function(e) {
                            if ((e.which === 9 && e.shiftKey)) {
                                if ((ifTurnedOff()) && (width > turnedOffabove())) {
                                    e.stopImmediatePropagation();
                                } else {
                                    if ($(this).hasClass('panel-opened')) {
                                        e.preventDefault();
                                        firstTabbable.focus();
                                    } else {
                                        e.stopImmediatePropagation();
                                    }
                                }
                            }
                        });
                        //redirect last tab to first input
                        lastTabbable.on('keydown', function(e) {
                            if ((e.which === 9 && !e.shiftKey)) {
                                if ((ifTurnedOff()) && (width > turnedOffabove())) {
                                    e.stopImmediatePropagation();
                                } else {
                                    e.preventDefault();
                                    firstTabbable.focus();
                                }
                            }
                        });
                        //redirect first shift+tab to last input
                        firstTabbable.on('keydown', function(e) {
                            if ((e.which === 9 && e.shiftKey)) {
                                if ((ifTurnedOff()) && (width > turnedOffabove())) {
                                    e.stopImmediatePropagation();
                                } else {
                                    e.preventDefault();
                                    lastTabbable.focus();
                                }
                            }
                        });
                    }


                    //all keys
                    ncr_panel.on('keyup', function(e) {
                        switch (e.which) {
                            case 27: // escape
                                if (!((ifTurnedOff() == true) && (width > turnedOffabove()))) {
                                    if (!(panel.hasClass('panel-no-trap'))) {

                                        if (ncr_panel.hasClass('ncr-turned-off')) {
                                            closeChildren(this);
                                        }
                                        ncr_panel_close_settings(ncr_toggle, panel_attr);
                                        ncr_toggle.focus();
                                        if (ncr_panel.hasClass('panel-pop')) {
                                            $('html').css('overflow-y', 'auto');
                                            $('html').css('position', 'relative');
                                        }

                                        e.stopImmediatePropagation();
                                    }
                                }
                                break;

                            case 37: // left
                                allElements.eq(allElements.index($(e)) + counter--, function() {}).focus();
                                //console.log("clicked left");
                                break;

                            case 38: // up
                                allElements.eq(allElements.index($(e)) + counter--).focus();
                                //console.log("clicked up");
                                break;

                            case 39: // right
                                allElements.eq(allElements.index($(e)) + counter++).focus();
                                //console.log("clicked right");
                                break;

                            case 40: // down
                                allElements.eq(allElements.index($(e)) + counter++).focus();
                                //console.log("clicked down");
                                break;

                            default:
                                return;
                        }

                    });

                }

                //if popout panel is open, it automatically tab traps in it
                if (ncr_panel.hasClass('panel-pop') && ncr_panel.hasClass('panel-opened')) {
                    var loaded_popout = $(document).find('.panel-pop.panel-opened');
                    $('html').css('overflow-y', 'hidden');
                    $('html').css('position', 'absolute');
                    trappingTab(loaded_popout);
                }

                var isItHover;
                var isItOff;

                $(window).on('load resize', function() {
                    isItHover = ncr_panel.hasClass('hover-toggle') && theWindow.width() >= turnedOffaboveNumber();
                    isItOff = ifTurnedOff() && theWindow.width() >= turnedOffaboveNumber();

                    //  console.log(ncr_toggle.attr('ncr-toggle'),'|hover: ',isItHover,'| off: ',isItOff, 'numb', turnedOffaboveNumber() )
                })


                //start of button functionality
                //toggle button
                ncr_toggle.on('click', function(e) {
                    var overlay_panels = $('body').find('[ncr-panel].panel-overlay');
                    var overlay_toggles = $('body').find('[ncr-toggle].panel-overlay');
                    var popout_panels = $('body').find('[ncr-panel].panel-pop.level-' + level);
                    var popout_toggles = $('body').find('[ncr-toggle].panel-pop.level-' + level);
                    var accordion_panels = $(this).parents('.feature-wrap').find('[ncr-panel].panel-accordion.level-' + level);
                    var accordion_toggles = $(this).parents('.feature-wrap').find('[ncr-toggle].panel-accordion.level-' + level);
                    var panel_child_panel = $(ncr_panel).find('> [ncr-panel].child-panel');

                    // console.log(accordion_panels, accordion_toggles)
                    function buttonFunctionality() {
                        if (ncr_toggle.hasClass('panel-pop', 'level-' + level)) {
                            if (ncr_panel.attr("aria-expanded") == 'false') {
                                e.stopImmediatePropagation();

                                popout_toggles.attr("aria-expanded", "true")
                                    .addClass("panel-closed")
                                    .removeClass("panel-opened");

                                popout_panels
                                    .attr("aria-expanded", "false")
                                    .removeClass("panel-opened")
                                    .addClass("panel-closed")
                                    .css('pointer-events', 'none');

                                popout_panels
                                    .find('select, input, textarea, button, a')
                                    .attr('tabIndex', '-1');

                                ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
                                trappingTab(ncr_panel);


                                $('html').css('overflow-y', 'hidden');
                                $('html').css('position', 'absolute');
                                $('html').css('width', '100%');

                                if (panel_child_panel.hasClass('ncr-turned-off')) {
                                    openChildren()
                                }
                            } else if (ncr_panel.attr("aria-expanded") == 'true') {
                                if (ncr_panel.hasClass('panel-pop')) {
                                    $('html').css('overflow-y', 'auto');
                                    $('html').css('position', 'relative');
                                }

                                ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
                                if ($(ncr_panel).hasClass('ncr-turned-off')) {
                                    trappingTab(this);
                                }
                            }
                        } else if (ncr_toggle.hasClass('panel-overlay')) {
                            if (ncr_panel.attr("aria-expanded") == 'false') {
                                e.stopImmediatePropagation();

                                overlay_toggles.attr("aria-expanded", "true")
                                    .addClass("panel-closed")
                                    .removeClass("panel-opened");

                                overlay_panels
                                    .attr("aria-expanded", "false")
                                    .removeClass("panel-opened")
                                    .addClass("panel-closed")
                                    .css('pointer-events', 'none');

                                overlay_panels
                                    .find('select, input, textarea, button, a')
                                    .attr('tabIndex', '-1');
                                ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
                                trappingTab(ncr_panel);

                                if (panel_child_panel.hasClass('ncr-turned-off')) {
                                    openChildren()
                                }
                            } else {
                                if (ncr_panel.hasClass('panel-pop')) {
                                    $('html').css('overflow-y', 'auto');
                                    $('html').css('position', 'relative');
                                }

                                ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
                                if ($(ncr_panel).hasClass('ncr-turned-off')) {
                                    trappingTab(this);
                                }
                            }
                        } else if (ncr_toggle.hasClass('panel-accordion', 'level-' + level)) {
                            if (ncr_panel.attr("aria-expanded") == 'false') {

                                accordion_toggles.attr("aria-expanded", "true")
                                    .addClass("panel-closed")
                                    .removeClass("panel-opened");

                                accordion_panels
                                    .attr("aria-expanded", "false")
                                    .removeClass("panel-opened")
                                    .addClass("panel-closed")
                                    .css('pointer-events', 'none');

                                accordion_panels
                                    .find('select, input, textarea, button, a')
                                    .attr('tabIndex', '-1');

                                ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
                                trappingTab(ncr_panel);
                                if (panel_child_panel.hasClass('ncr-turned-off')) {
                                    openChildren()
                                }
                            } else {
                                if (!(ncr_panel.hasClass('panel-cant-close') && ncr_panel.hasClass('panel-opened'))) {
                                    if (ncr_panel.hasClass('panel-pop')) {
                                        $('html').css('overflow-y', 'auto');
                                        $('html').css('position', 'relative');
                                    }
                                    ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
                                    if ($(ncr_panel).hasClass('ncr-turned-off')) {
                                        trappingTab(this);
                                    }
                                }

                            }
                        } else {
                            if (ncr_panel.attr("aria-expanded") == 'false') {
                                $(this).trigger("ncr-panel-open", function() {
                                    //console.log('opened - call ncr-panel-open');
                                });
                                ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
                                trappingTab(ncr_panel);
                                if (panel_child_panel.hasClass('ncr-turned-off')) {
                                    openChildren()
                                }
                            } else {
                                if (ncr_panel.hasClass('panel-pop')) {
                                    $('html').css('overflow-y', 'auto');
                                    $('html').css('position', 'relative');
                                }
                                $(this).trigger("ncr-panel-close", function() {
                                    //console.log('closed - call ncr-panel-close');
                                });

                                ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
                                if ($(ncr_panel).hasClass('ncr-turned-off')) {
                                    trappingTab(this);
                                }
                            }
                        }

                    }
                    if (!((ifTurnedOff()) && (width > turnedOffabove()))) {
                        buttonFunctionality();
                        if (!(ncr_panel.hasClass('panel-no-trap'))) {
                            ncr_toggle.keyup(function(e) {
                                if (e.keyCode == 27) {

                                    if ($(this).hasClass('panel-pop')) {
                                        $('html').css('overflow-y', 'auto');
                                        $('html').css('position', 'relative');
                                    }
                                    ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
                                    if ($(ncr_panel).hasClass('ncr-turned-off')) {
                                        trappingTab(this);
                                    }
                                    $(this).focus();
                                    // console.log('escaped not')  
                                }
                            });
                            e.stopImmediatePropagation();
                        }

                    } else if ((ncr_panel.hasClass('ncr-panel-off'))) {
                        ncr_toggle.keyup(function(e) {
                            if (e.keyCode == 27) {
                                // console.log('escaped')
                            }
                        });
                    }
                });

                $(ncr_toggle).parents('.feature').offset(ncr_panel).on('mouseover', function() {
                    if (isItHover) {
                        var panel_child_panel = $(ncr_panel).find('.child-panel[ncr-panel]');
                        ncr_panel_open_settings(ncr_toggle, panel_attr);
                        trappingTab(ncr_panel);
                        if ($(panel_child_panel).hasClass('ncr-turned-off')) {
                            openChildren()
                        }
                    } else {

                    }
                });

                $(ncr_toggle).parents('.feature').offset(ncr_panel).on('mouseleave', function() {
                    if (isItHover) {
                        ncr_panel_close_settings(ncr_toggle, panel_attr);
                    } else {

                    }
                });

                //close button
                close_button.on('click', function(e) {
                    if (!($(this).parent('[ncr-panel]').hasClass('ncr-turned-off'))) {
                        var ncr_panel = $(this).parents('.panel-opened').attr('ncr-panel');
                        var ncr_toggle = $('[ncr-toggle="' + ncr_panel + '"');

                        // console.log('working');
                        $('html').css('overflow-y', 'auto');
                        $('html').css('position', 'relative');

                        ncr_panel_close_settings(ncr_toggle, ncr_panel);
                        if ($(ncr_panel).hasClass('ncr-turned-off')) {
                            closeChildren();
                        }
                        ncr_toggle.focus();

                        e.stopImmediatePropagation();
                    }
                });

                //panel-pop
                popout_bg.on('click', function(e) {
                    if ((ifTurnedOff()) && (width > turnedOffabove())) {
                        e.stopImmediatePropagation();
                    } else {
                        var ncr_panel = $(this).parents('div').attr('ncr-panel');



                        ncr_panel_close_settings(ncr_toggle, ncr_panel);
                        if ($(ncr_panel).hasClass('ncr-turned-off')) {
                            closeChildren();
                        }

                        ncr_toggle.focus();
                        if ($(this).parents('div[ncr-panel]').hasClass('panel-pop')) {
                            $('html').css('overflow-y', 'auto');
                            $('html').css('position', 'relative');
                        }
                        e.stopImmediatePropagation();
                    }
                });

                //panel-overlay stop from closing if clicked outside of selector
                overlay_panel.on('click', function(e) {
                    e.stopImmediatePropagation();
                });

                //panel-pop stop from closing if clicked outside of selector
                popout_panel.on('click', function(e) {
                    e.stopImmediatePropagation();
                });

                //space button
                ncr_toggle.keyup(function(e) {
                    if ((ifTurnedOff()) && (width > turnedOffabove())) {
                        e.stopImmediatePropagation();
                    } else {
                        if (e.keyCode == 32) {
                            e.preventDefault();
                            var ncr_panel = $('div[ncr-panel="' + panel_attr + '"]');
                            if (ncr_panel.attr("aria-expanded") == 'false') {
                                ncr_panel_open_settings(ncr_panel, panel_attr);
                                trappingTab(ncr_panel);
                                e.stopImmediatePropagation();
                            }

                        }
                    }
                });




                //if turnOff is true, do these things
                //from class to class function
                function switchClassesAbove() {
                    if (ncr_panel.is('[class*=switch-]')) {
                        var result = undefined;
                        $(ncr_panel.attr('class').split(' ')).each(function() {
                            if (this.indexOf('switch-') > -1) result = this;
                        });
                        var res = result.split('-')[1];
                    } else {
                        return res = 'on';
                    }
                    return res;
                }

                function fromClass() {
                    if (ncr_panel.is('[class*=switch-]')) {
                        var fromClass = undefined;
                        $(ncr_panel.attr('class').split(' ')).each(function() {
                            if (this.indexOf('switch-') > -1) fromClass = this;
                        });
                        var from = fromClass.split('-')[3];
                    } else {
                        return from = 'on';
                    }
                    return 'panel-' + from;
                }

                function toClass() {
                    if (ncr_panel.is('[class*=switch-]')) {
                        var toClass = undefined;
                        $(ncr_panel.attr('class').split(' ')).each(function() {
                            if (this.indexOf('switch-') > -1) toClass = this;
                        });
                        var to = toClass.split('-')[2];
                    } else {
                        return to = 'on';
                    }
                    return 'panel-' + to;
                }

                function fromToClass() {
                    if (width < switchClassesAbove()) {
                        ncr_toggle.addClass(fromClass());
                        ncr_panel.addClass(fromClass());
                        ncr_toggle.removeClass(toClass());
                        ncr_panel.removeClass(toClass());
                    } else {
                        ncr_toggle.addClass(toClass());
                        ncr_panel.addClass(toClass());
                        ncr_toggle.removeClass(fromClass());
                        ncr_panel.removeClass(fromClass());
                    }
                }

                function adjustClasses() {
                    if ((ifTurnedOff()) && (width >= turnedOffabove())) {
                        ncr_panel.addClass('ncr-turned-off');
                        ncr_toggle.addClass('ncr-toggle-turned-off');

                        if (ncr_panel.hasClass('panel-overlay')) {
                            isitoverlay = true;
                        }
                        ncr_toggle.removeClass('panel-overlay');
                        ncr_panel.removeClass('panel-overlay');

                        if (ncr_panel.hasClass('panel-pop')) {
                            isitpop = true;
                        }

                        ncr_panel.removeClass('panel-pop');
                        ncr_toggle.removeClass('panel-pop');

                        ncr_toggle.css('pointer-events', 'auto');
                        ncr_panel.css('pointer-events', 'none');
                        ncr_panel.find('select, input, textarea, button, a').css('pointer-events', 'auto');
                    } else {
                        ncr_panel.removeClass('ncr-turned-off');
                        ncr_toggle.removeClass('ncr-toggle-turned-off');

                        if (isitoverlay) {
                            ncr_toggle.addClass('panel-overlay');
                            ncr_panel.addClass('panel-overlay');
                        }
                        if (isitpop) {
                            ncr_panel.addClass('panel-pop');
                            ncr_toggle.addClass('panel-pop');
                        }
                        ncr_toggle.css('pointer-events', 'auto');
                        ncr_panel.css('pointer-events', 'auto');
                    }
                }

                if (ifTurnedOff() === true) {
                    //turn off open the panel/toggle function
                    function open(btn, area) {
                        btn
                            .attr("aria-expanded", "true")
                            .addClass("panel-opened")
                            .removeClass("panel-closed")

                        area
                            .attr("aria-expanded", "true")
                            .addClass("panel-opened")
                            .removeClass("panel-closed")
                            .css('pointer-events', 'auto')

                        area
                            .find('select, input, textarea, button, a')
                            .removeAttr('tabIndex');
                    }
                    //turn off close the panel/toggle function
                    function close(btn, area) {
                        btn
                            .attr("aria-expanded", "true")
                            .addClass("panel-closed")
                            .removeClass("panel-opened");

                        area
                            .attr("aria-expanded", "false")
                            .removeClass("panel-opened")
                            .addClass("panel-closed")
                            .css('pointer-events', 'none');

                        area
                            .find('select, input, textarea, button, a')
                            .attr('tabIndex', '-1');


                        $('html').css('overflow-y', 'auto');
                        $('html').css('position', 'relative');
                    }
                    //turning on and off panels/toggle + handles overlays and popouts if turned off 
                    function overlaySettingsTurnedOff() {
                        if (width < turnedOffabove()) {
                            close(ncr_toggle, ncr_panel);
                        } else {
                            open(ncr_toggle, ncr_panel);
                        }

                        if (settings.overlay == true || settings.popout == true) {
                            if (width < turnedOffabove()) {


                            } else {

                            }
                        }
                    }

                    //turn off function start based on width only resize when resizing

                    //turn off function start based on width only resize when loaded
                    overlaySettingsTurnedOff();
                }
                fromToClass();
                adjustClasses();
                //on resize width only browser check
                theWindow.on('window:resize', function() {
                    if ($(this).width() != width) {
                        width = $(this).width();

                        if (ifTurnedOff()) {
                            //turn off open the panel/toggle function
                            function open(btn, area) {
                                btn
                                    .attr("aria-expanded", "true")
                                    .addClass("panel-opened")
                                    .removeClass("panel-closed")

                                area
                                    .attr("aria-expanded", "true")
                                    .addClass("panel-opened")
                                    .removeClass("panel-closed")
                                    .css('pointer-events', 'auto')
                                area
                                    .find('select, input, textarea, button, a')
                                    .removeAttr('tabIndex');
                            }
                            //turn off close the panel/toggle function
                            function close(btn, area) {
                                btn
                                    .attr("aria-expanded", "true")
                                    .addClass("panel-closed")
                                    .removeClass("panel-opened");

                                area
                                    .attr("aria-expanded", "false")
                                    .removeClass("panel-opened")
                                    .addClass("panel-closed")
                                    .css('pointer-events', 'none');

                                area
                                    .find('select, input, textarea, button, a')
                                    .attr('tabIndex', '-1');


                                $('html').css('overflow-y', 'auto');
                                $('html').css('position', 'relative');
                            }
                            //turning on and off panels/toggle + handles overlays and popouts if turned off 
                            function overlaySettingsTurnedOff() {
                                if (width < turnedOffabove()) {
                                    close(ncr_toggle, ncr_panel);

                                } else {
                                    open(ncr_toggle, ncr_panel);
                                }

                                if (settings.overlay == true || settings.popout == true) {
                                    if (width < turnedOffabove()) {


                                    } else {

                                    }
                                }
                            }

                            //turn off function start based on width only resize when resizing

                            //turn off function start based on width only resize when loaded
                            overlaySettingsTurnedOff();
                        }

                        fromToClass();
                        adjustClasses();
                    }
                });


                if (settings.panelOpen || settings.panelClose == true) {
                    ncr_toggle.trigger('click');
                    ncr_toggle.focus();
                }

                if (typeof callback == 'function') { // make sure the callback is a function
                    callback.call(this); // brings the scope to the callback
                }

            }) // end of foreach


        if ($('.feature-wrap').hasClass('first-open')) {
            $($('.first-open')).each(function() {
                var firstChild = $('.first-open').find('[ncr-panel]').first();
                // console.log(firstChild.attr('ncr-panel'));
                firstChild.trigger('ncr-open-panel');
            })

        };

        if ($('.feature-wrap').hasClass('all-open')) {
            $($('.all-open')).each(function() {
                var panels = $('.all-open').find('[ncr-panel]');
                // console.log(panels.attr('ncr-panel'));
                panels.each(function() {
                    $(this).trigger('ncr-open-panel');
                })
            })
        };

        //panel-overlay
        $(document).on('click', function() {

            if ($('div.panel-overlay:not(.ncr-turned-off)').hasClass('panel-opened')) {


                $('[ncr-toggle].panel-overlay')
                    .attr("aria-expanded", "false")
                    .addClass("panel-closed")
                    .removeClass("panel-opened");

                $('div[ncr-panel].panel-overlay')
                    .attr("aria-expanded", "false")
                    .removeClass("panel-opened")
                    .addClass("panel-closed")
                    .css('pointer-events', 'none');

                $('div[ncr-panel].panel-overlay')
                    .find('select, input, textarea, button, a')
                    .attr('tabIndex', '-1');
            }
        });
    }


    ///////////////////////////////////////////////////////////////////////////
    //tabTrapping 5.0 end                                                    //
    ///////////////////////////////////////////////////////////////////////////
























    //////////////////////////////////////////////////////////////////////////////
    //tabTrapping 6.0
    //////////////////////////////////////////////////////////////////////////////
    //
    // to intitualize this plugin all you have to do is add this to your javascript file:
    //
    //////////////////////////////////////////////////////////////
    // $("body").tabTrapping();
    //////////////////////////////////////////////////////////////
    //
    // this is an empty panel, you have to have it closed or opened
    // you need ether = "panel-closed or panel-opened" in class
    // if you want it to close if you click anything else, add "panel-overlay" class to it
    // if its a popout type of panel, add "panel-pop", a div with a 
    // class of ".popout-bg" will appear in inside the panel div
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //																												//											
    //      <div class="(panel-closed or panel-opened)(panel-overlay, panel-pop, or none)" ncr-panel="menu"></div>		//
    //																												//
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //
    // this is the panel toggle, you have to have it closed or opened
    // the panel-closed or panel-opened class will show up automatilly depending on what you put in the panel
    //////////////////////////////////////////////////////////////
    //															//
    //          <a href="#" ncr-toggle="menu"></a>				//
    //															//
    //////////////////////////////////////////////////////////////
    //
    //
    // put this button inside a panel-pop, to close it with a button.
    //////////////////////////////////////////////////////////////
    //															//
    //			<a href="#" class="close-button"></a>           //
    //														    //
    //////////////////////////////////////////////////////////////

    $.fn.tabTrappingClassBased = function(options, callback) {

        var settings = $.extend({
            preloadRemoveDelay: 0
        }, options)

        class Panel {
            constructor(panel) {
                this.panel = panel;
                this.name = this.panel.attr('ncr-panel');
                this.toggle = $('[ncr-toggle="' + this.name + '"]');
                this.closeButton = this.panel.find('.close-button:first');
                this.isOff = this.panel.is('[class*=panel-off-]');
                this.isOpen = this.panel.hasClass('panel-opened');
                this.level = this.panel.parents('[ncr-panel]').length + 1;
                this.turnedOffAbove = this.turnedOffAbove();
                this.childrenPanels = this.panel.find('[ncr-panel]');
                this.childrenPanelsToggle = this.panel.find('[ncr-toggle]');

                this._initialize();
            }

            findType() {
                if (this.panel.hasClass('panel-overlay')) {
                    return "panel-overlay";
                } else if (this.panel.hasClass('panel-accordion')) {
                    return "panel-accordion";
                } else if (this.panel.hasClass('panel-pop')) {
                    return "panel-pop";
                } else {
                    return "panel-none";
                }
            }

            openPanel() {
                this.toggle
                    .attr("aria-expanded", "true")
                    .addClass("panel-opened")
                    .removeClass("panel-closed");

                this.panel
                    .attr("aria-expanded", "true")
                    .addClass("panel-opened")
                    .removeClass("panel-closed")
                    .css('pointer-events', 'auto');

                this.panel
                    .find('select, input, textarea, button, a')
                    .attr('tabIndex', '0')

                this.panel
                    .find('.panel-closed[ncr-panel]')
                    .find('select, input, textarea, button, a')
                    .attr('tabIndex', '-1');

                this.panel.trigger('ncr-panel-opened');

            }

            closePanel() {
                this.toggle
                    .attr("aria-expanded", "false")
                    .addClass("panel-closed")
                    .removeClass("panel-opened");


                this.panel
                    .attr("aria-expanded", "false")
                    .removeClass("panel-opened")
                    .addClass("panel-closed")
                    .css('pointer-events', 'none');

                this.panel
                    .find('select, input, textarea, button, a')
                    .attr('tabIndex', '-1');

                this.panel.trigger('ncr-panel-closed');
            }

            trappingTab() {
                // console.log('tt ran')
                var allElements = this.panel.find(':not([ncr-panel].panel-closed, [ncr-panel].panel-closed *)');
                var tabbable = allElements.filter('select:visible, input:visible, textarea:visible, a:visible, button:visible');

                var firstTabbable = tabbable.first();
                var lastTabbable = tabbable.last();


                //set focus on first input

                firstTabbable.focus();



                //first tab
                this.panel.on('keydown', function(e) {
                    if ((e.which === 9 && !e.shiftKey)) {
                        if (this.turnedOffAbove < theWindow.innerWidth) {
                            e.stopImmediatePropagation();
                        } else {
                            if ($(this).hasClass('panel-opened')) {
                                e.preventDefault();
                                firstTabbable.focus();
                            } else {
                                e.stopImmediatePropagation();
                            }
                        }
                    }
                });

                //check if to traptab or not
                if (!(this.panel.hasClass('panel-no-trap'))) {
                    //first shift-tab
                    this.toggle.on('keydown', function(e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            if (this.turnedOffAbove < theWindow.innerWidth) {
                                e.stopImmediatePropagation();
                            } else {
                                if ($(this).hasClass('panel-opened')) {
                                    e.preventDefault();
                                    firstTabbable.focus();
                                } else {
                                    e.stopImmediatePropagation();
                                }
                            }
                        }
                    });
                    //redirect last tab to first input
                    lastTabbable.on('keydown', function(e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            if (this.turnedOffAbove < theWindow.innerWidth) {
                                e.stopImmediatePropagation();
                            } else {
                                e.preventDefault();
                                firstTabbable.focus();
                            }
                        }
                    });
                    //redirect first shift+tab to last input
                    firstTabbable.on('keydown', function(e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            if (this.turnedOffAbove < theWindow.innerWidth) {
                                e.stopImmediatePropagation();
                            } else {
                                e.preventDefault();
                                lastTabbable.focus();
                            }
                        }
                    });
                }


                //all keys
                this.panel.on('keyup', function(e) {
                    switch (e.which) {
                        case 27: // escape
                            // console.log('escape clicked')
                            // if(!(panel.hasClass('panel-no-trap'))){

                            //     if (this.panel.hasClass('ncr-turned-off')) {
                            //         closeChildren(this);
                            //     }
                            //     ncr_panel_close_settings(ncr_toggle, panel_attr);
                            //     this.toggle.focus();
                            //     if (this.panel.hasClass('panel-pop')) {
                            //         $('html').css('overflow-y', 'auto');
                            //         $('html').css('position', 'relative');
                            //     }

                            //     e.stopImmediatePropagation();
                            // }

                            break;

                        case 37: // left
                            allElements.eq(allElements.index($(e)) + counter--, function() {}).focus();
                            //console.log("clicked left");
                            break;

                        case 38: // up
                            allElements.eq(allElements.index($(e)) + counter--).focus();
                            //console.log("clicked up");
                            break;

                        case 39: // right
                            allElements.eq(allElements.index($(e)) + counter++).focus();
                            //console.log("clicked right");
                            break;

                        case 40: // down
                            allElements.eq(allElements.index($(e)) + counter++).focus();
                            //console.log("clicked down");
                            break;

                        default:
                            return;
                    }

                });

            }

            turnedOffAbove() {
                if (!this.isOff) {
                    return undefined;
                }
                return this.panel.attr('class')
                    .split(' ')
                    .find(function(className) {
                        return className.indexOf('panel-off-') > -1;
                    })
                    .split('-')[2];
            }

            turnOnPanel() {
                this.panel.removeClass('ncr-turned-off');

                this.closePanel()
                    // console.log( this.name, this.turnedOffAbove < theWindow.innerWidth, 'ON');
            }

            turnOffPanel() {
                this.panel.addClass('ncr-turned-off');
                this.openPanel()
                    // console.log( this.name, this.turnedOffAbove < theWindow.innerWidth, 'OFF');
            }

            _initialize() {

                //panels
                this.panel.addClass('level-' + this.level);
                this.panel.attr("aria-expanded", this.isOpen);
                this.panel.attr('aria-label', this.name + ' Primary');

                //toggles
                this.toggle.css('pointer-events', 'auto');
                this.toggle.attr('aria-label', this.name + ' Toggle');
                this.toggle.attr("aria-expanded", this.isOpen);
                this.toggle.addClass('level-' + this.level);

                //close button
                this.closeButton.attr('aria-label', `${this.name} close Button`);
                if (!this.isOpen) {
                    this.panel.css('pointer-events', 'none');
                    this.panel.find('select, input, textarea, button, a').attr('tabIndex', '-1');
                }
                if (this.isOff && this.turnedOffAbove < theWindow.innerWidth) {
                    this.panel.addClass('ncr-turned-off');
                    this.panel.removeClass('panel-pop');
                }
            }

        }

        var allPanels = $('body').find('[ncr-panel]').map(function() {
            return new Panel($(this));
        });



        allPanels.each(function() {
            this.toggle.click(() => {
                if (this.panel.hasClass('panel-opened')) {
                    this.closePanel();
                } else {
                    this.openPanel();
                    this.trappingTab();
                }
            })

            this.closeButton.click(() => {
                this.closePanel();
            })

            theWindow.on('window:resize', () => {
                var addNew = true;
                if (this.turnedOffAbove < theWindow.innerWidth && addNew) {

                    this.turnOffPanel();
                    addNew = false;
                    console.log('turned off')
                } else {
                    console.log('turned off')
                    this.turnOnPanel();
                }
            })

        })

        theWindow.on('window:resize', () => {
            return $('body').find('[ncr-panel]').map(function() {
                return new Panel($(this));
            });

        })

    }

    ///////////////////////////////////////////////////////////////////////////
    //tabTrapping 6.0 end                                                    //
    ///////////////////////////////////////////////////////////////////////////


})(jQuery); // or even jQuery.noConflict()